<span style="filter: brightness(0) saturate(100%) invert(77%) sepia(19%) saturate(6799%) hue-rotate(9deg) brightness(100%) contrast(106%);" >
    <slot />
</span>